import { countries } from "@/constants/countries";

const useDetectFlag = (code: string) => {
  const country = countries.find((item) => item.code === code);
  return country;
};

export default useDetectFlag;
